<template>
  <div class="card">
    <div class="card-body">
      <h4 class="filter-title mb-3">Filter Options</h4>

      <!-- City -->
      <div class="filter-group mb-3">
        <h6>City:</h6>
        <select v-model="selectedFilters.city" class="form-control">
          <option value="">Selecione</option>
          <option v-for="city in cities" :key="city" :value="city">{{ city }}</option>
        </select>
      </div>

      <!-- Ano Range -->
      <div class="filter-group mb-3">
        <h6>Ano Range:</h6>
        <div class="input-group mb-3">
          <input
            id="min-year"
            type="number"
            class="form-control"
            v-model.number="selectedFilters.minAno"
            :min="yearRange[0]"
            :max="yearRange[1]"
            step="1"
            placeholder="De:"
            value="0"
          />
          <input
            id="max-year"
            type="number"
            class="form-control"
            v-model.number="selectedFilters.maxAno"
            :min="yearRange[0]"
            :max="yearRange[1]"
            step="1"
            placeholder="Até:"
            value="0"
          />
        </div>
        <div id="slider-range-ano" class="ui-slider ui-slider-horizontal"></div>
      </div>

      <!-- Price Range -->
      <div class="filter-group mb-4">
        <h6>Price Range:</h6>
        <div class="input-group mb-3">
          <input
            id="min-price"
            type="number"
            class="form-control"
            v-model.number="selectedFilters.minPrice"
            min="0"
            :max="priceRange[1]"
            step="500"
            placeholder="De:"
            value="0"
          >
          <input
            id="max-price"
            type="number"
            class="form-control"
            v-model.number="selectedFilters.maxPrice"
            min="0"
            :max="priceRange[1]"
            step="500"
            placeholder="Até:"
            value="0"
          >
        </div>
        <div id="slider-range-price" class="ui-slider ui-slider-horizontal"></div>
      </div>

      <!-- Cor -->
      <div class="filter-group mb-3">
        <h6>Cor:</h6>
        <select v-model="selectedFilters.color" class="form-control">
          <option value="">Selecione</option>
          <option v-for="color in colors" :key="color" :value="color">{{ color }}</option>
        </select>
      </div>

      <!-- Opcionais -->
      <div class="filter-group mb-3">
        <h6>Opcionais:</h6>
        <div class="form-check" v-for="option in options" :key="option">
          <input
            type="checkbox"
            class="form-check-input"
            :id="`option-${option}`"
            :value="option"
            v-model="selectedFilters.options"
          />
          <label class="form-check-label" :for="`option-${option}`">
            {{ option }}
          </label>
        </div>
      </div>

      <button @click="applyFilters" class="btn btn-primary">Aplicar Filtros</button>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted } from "vue";
  import $ from "jquery"; // Importa o jQuery
  import "jquery-ui/ui/widgets/slider";
  import "jquery-ui/themes/base/slider.css";

  export default {
    props: {
      cities: {
        type: Array,
        default: () => [],
      },
      yearRange: {
        type: Array,
        default: () => [1990, 2025],
      },
      priceRange: {
        type: Array,
        default: () => [1000, 10000],
      },
      colors: {
        type: Array,
        default: () => [],
      },
      options: {
        type: Array,
        default: () => ['Ar', 'Direção'],
      },
      initialFilters: {
        type: Object,
        default: () => ({
          minPrice: 1000,
          maxPrice: 10000,
          minAno: 1990,
          maxAno: 2025,
          city: "",
          color: "",
          options: [],
        }),
      },
    },
    setup(props, { emit }) {
      // Filtros selecionados (reativos)
      const selectedFilters = ref({ ...props.initialFilters });

      // Função para aplicar os filtros
      const applyFilters = () => {
        emit("update-filters", selectedFilters.value);
      };

      // Inicialização dos sliders
      const initSliders = () => {
        const sliderConfig = {
          range: true,
          min: 1000,
          max: 10000,
          step: 500,
          values: [1000, 10000],
          slide(event, ui) {
            updateInputs(ui.values[0], ui.values[1]);
          },
        };

        // Inicializa o slider
        $("#slider-range-price").slider(sliderConfig);

        // Inicializa os valores dos inputs com os valores do slider
        const updateInputs = (minValue, maxValue) => {
          $("#min-price").val(minValue);
          $("#max-price").val(maxValue);
        };

        const updateSlider = (inputId, valueIndex) => {
          const value = parseInt($(inputId).val(), 10) || 0;
          const currentValues = $("#slider-range-price").slider("values");
          currentValues[valueIndex] = value;

          // Garante que os valores sejam consistentes
          if (valueIndex === 0 && currentValues[0] > currentValues[1]) {
            currentValues[0] = currentValues[1];
          } else if (valueIndex === 1 && currentValues[1] < currentValues[0]) {
            currentValues[1] = currentValues[0];
          }

          $("#slider-range-price").slider("values", currentValues);
          updateInputs(currentValues[0], currentValues[1]);
        };

        // Atualiza os valores iniciais nos inputs
        updateInputs(sliderConfig.values[0], sliderConfig.values[1]);

        // Atualiza o slider ao alterar os inputs
        $("#min-price").on("input", function () {
          updateSlider("#min-price", 0);
        });

        $("#max-price").on("input", function () {
          updateSlider("#max-price", 1);
        });
      };

      // Montagem do componente
      onMounted(() => {
        initSliders();
      });

      return {
        selectedFilters,
        applyFilters,
      };
    },
  };
</script>
  
<style>
  .filter-container {
      background: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 5px;
    }
    
    .filter-title {
      font-weight: bold;
      color: #343a40;
    }
    
    .ui-slider {
      position: relative;
      height: 5px;
      background: #ddd;
      border-radius: 5px;
    }
    
    .ui-slider .ui-slider-handle {
      width: 20px;
      height: 20px;
      background: var(--primary);
      border-radius: 50%;
      position: absolute;
      top: -8px;
      cursor: pointer;
    }
    
    .ui-slider .ui-slider-range {
      background: var(--primary);
      border-radius: 5px;
    }
    
    .filter-group h6 {
      font-weight: bold;
      color: #495057;
    }
</style>
